export default "__VITE_ASSET__BbPFV18B__"